import React from 'react';
import { getContext } from 'common';
import Styled from './styles';

export interface CoachmarkCloseButtonProps extends React.ComponentPropsWithRef<'div'> {
  /** Content is placed here. */
  children: React.ReactNode;
}

/** Coachmark close button wrapper.
 * All additional props will be forwarded to the root element.
*/
const CoachmarkCloseButton = React.forwardRef<HTMLElement, CoachmarkCloseButtonProps>((props: CoachmarkCloseButtonProps, ref) =>
  getContext(({ RTL }) => <Styled.CoachmarkCloseButton $rtl={RTL} ref={ref} {...props} />));

CoachmarkCloseButton.displayName = 'CoachmarkCloseButton';

/* Exports */
export { CoachmarkCloseButton as default };
